export default "__VITE_ASSET__CspMt$LN__"